export const GET_ADDRESSES = 'addresses';
export const GET_CATEGORIES = 'categories';
export const GET_TRACKING_NUMBER_IMPORT_RESULTS = 'tracking-number-import-results';
export const UPDATE_TRACKING_NUMBER_IMPORT_RESULTS = 'update-tracking-number-import-results';
